import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";

const createClientEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: event =>
      createEventFunc({
        ...payload,
        path: `_hook.${hookId}`,
        slots: () => [
          ...((payload?.slots && payload?.slots(event)) || []),
          {
            slot: "name",
            is: "strong",
            message: _.get(event, "object.fullname", _.get(event, "object_id"))
          }
        ]
      })(event)
  }
});

export default {
  ...createClientEventMap(HookCodes.CLIENT_ADDED_TWO_FACTOR_AUTH, {
    icon: icon.success
  }),
  ...createClientEventMap(HookCodes.CLIENT_REMOVED_TWO_FACTOR_AUTH, {
    icon: icon.danger
  }),
  ...createClientEventMap(HookCodes.CLIENT_LOGGED_IN, {
    icon: icon.lock
  }),
  ...createClientEventMap(HookCodes.CLIENT_UPDATED),
  ...createClientEventMap(HookCodes.CLIENT_WAS_IMPERSONATED),
  ...createClientEventMap(HookCodes.CLIENT_ADDRESS_CREATED, {
    icon: icon.success,
    slots: event => [
      {
        slot: "address",
        is: "strong",
        message: _.get(event, "object.name")
      }
    ]
  }),
  ...createClientEventMap(HookCodes.CLIENT_REGISTERED, {
    icon: icon.success
  }),
  ...createClientEventMap(HookCodes.CLIENT_DELETED, {
    icon: icon.danger,
    slots: event => [
      {
        slot: "id",
        is: "strong",
        message: `#${_.get(event, "object_id")}`
      }
    ]
  }),
  ...createClientEventMap(HookCodes.CLIENT_REQUESTED_PASSWORD_RESET),
  ...createClientEventMap(HookCodes.CLIENT_PASSWORD_WAS_RESET),
  ...createClientEventMap(HookCodes.CLIENT_VERIFICATION_REQUIRED),
  ...createClientEventMap(HookCodes.CLIENT_ADDRESS_UPDATED),
  ...createClientEventMap(HookCodes.CLIENT_ADDRESS_DELETED, {
    icon: icon.danger
  }),
  ...createClientEventMap(HookCodes.CLIENT_PASSWORD_CHANGED),
  ...createClientEventMap(HookCodes.CLIENT_LOGIN_EMAIL_UPDATED),
  ...createClientEventMap(HookCodes.CLIENT_EXCEEDED_MAX_INCORRECT_LOGINS)
};
